import { RewardsCustomerRewardsSchema } from "@modules/nudges/schemas/RewardsCustomerSchemas/RewardsCustomerRewardsSchema";
import { Infer, array, object } from "superstruct";

export const RewardsCustomerRewardsResponseSchema = object({
    rewards: array(RewardsCustomerRewardsSchema),
});

export type RewardsCustomerRewardsResponseType = Infer<
    typeof RewardsCustomerRewardsResponseSchema
>;
